/**
 * Ponteiro de geração ativa para persistência atômica.
 */

import { idbGetMeta, idbPutMeta, type StorageMetaRecord } from './idbQueueDb';
import { computeQueueChecksum } from '../queueIntegrity';
import type { QueueItem } from '../queue/types';

const META_KEY = 'queue_meta';

export async function readGenerationPointer(): Promise<StorageMetaRecord | null> {
  return idbGetMeta();
}

export async function writeGenerationPointer(
  items: QueueItem[],
  generation: number
): Promise<StorageMetaRecord> {
  const record: StorageMetaRecord = {
    key: META_KEY,
    activeGeneration: generation,
    itemCount: items.length,
    checksum: computeQueueChecksum(items),
    updatedAt: Date.now(),
  };
  await idbPutMeta(record);
  return record;
}

export function validateGenerationPointer(
  items: QueueItem[],
  meta: StorageMetaRecord | null
): boolean {
  if (!meta) return items.length === 0;
  return (
    meta.itemCount === items.length &&
    meta.checksum === computeQueueChecksum(items)
  );
}

export function nextGeneration(current: number | null): number {
  return (current ?? 0) + 1;
}
